import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

function counterFunction() {
	if($('.wp-block-krutablocks-counters').length) {
		$('.wp-block-krutablocks-counters').each(function() {
		    var self = $(this),
		        bar = self.find('.wp-block-krutablocks-counter');
		    bar.each(function() {
			    var count = $(this).find('.wp-block-krutablocks-counter__number'),
			        zero = {val:0},
			        num = count.data("number"),
			        split = (num + "").split("."),
			        decimals = split.length > 1 ? split[1].length : 0;

			    gsap.to(zero, {
					scrollTrigger: {
					    trigger: self[0],
						start: "+=100 bottom",
					},
					duration: 2,
					val: num,
					onUpdate: function() {
			            count.text(zero.val.toFixed(decimals));
			        }
				});
			});
		});
	}
}
$(window).on('load', () => {
  if($('.c-loader').length) {
    setTimeout(() => { 
          counterFunction();
      }, 3200);
  } else {
    setTimeout(() => { 
          counterFunction();
      }, 400);
  }
})